var map = {
	"./ADA.svg": 975,
	"./BCH.svg": 976,
	"./BNB.svg": 977,
	"./BTC.svg": 978,
	"./CHZ.svg": 979,
	"./DASH.svg": 980,
	"./DOGE.svg": 981,
	"./DOT.svg": 982,
	"./ETC.svg": 983,
	"./ETH.svg": 984,
	"./EUR.svg": 985,
	"./GBP.svg": 986,
	"./LINK.svg": 987,
	"./LTC.svg": 988,
	"./MATIC.svg": 989,
	"./MKR.svg": 990,
	"./SHIB.svg": 991,
	"./SOL.svg": 992,
	"./TRX.svg": 993,
	"./UNI.svg": 994,
	"./USD.svg": 995,
	"./USDT.svg": 996,
	"./XLM.svg": 997,
	"./XMR.svg": 998,
	"./XRP.svg": 999,
	"./documents.svg": 1000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;